// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"__404_errorPage__Zl_i0","waveMask":"__404_waveMask__ghq31","errorBtnWrapper":"__404_errorBtnWrapper__x4aBn","primary-blue-bg":"__404_primary-blue-bg__L51C1"};